import React, { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Collapse, Divider } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import { TUser } from 'ui-model';

import { Button, Tooltip } from 'components/v2';
import { MessageAvatar } from '../MessageAvatar';
import styles from './Thread.styles';
import messages from './Thread.messages';

export interface ThreadProps extends WithStyles<typeof styles> {
  interlocutor: TUser;
  initialMessage: string;
  MessageDetailsComponent?: React.ReactElement;
}

export const Thread: React.FC<ThreadProps> = ({
  children,
  interlocutor,
  initialMessage,
  classes,
  MessageDetailsComponent,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <div className={classes.root} ref={ref}>
      {open && <Divider className={classes.divider} />}
      {!open && (
        <div className={classes.wrapper}>
          <div className={classes.pullBottom}>
            <MessageAvatar interlocutor={interlocutor} size="xsmall" />
          </div>
          <Tooltip title="Click here to expand">
            <div className={classes.messageWrapper} onClick={() => setOpen(true)}>
              <div className={classes.messageContent}>{initialMessage}</div>
              {MessageDetailsComponent}
            </div>
          </Tooltip>
          <Tooltip title="Click here to expand">
            <Button
              variant="contained"
              className={classes.showMoreButton}
              color="primary"
              onClick={() => setOpen(true)}
            >
              <ArrowDropDown />
            </Button>
          </Tooltip>
        </div>
      )}
      <Collapse in={open}>{children}</Collapse>
      {open && (
        <div className={classes.collapseDiv}>
          <Divider className={classes.collapseDivider} />
          <Button
            onClick={() => {
              setOpen(false);
              ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
            variant="contained"
            className={classes.collapseButton}
            color="primary"
          >
            {formatMessage(messages.collapse)}
          </Button>
          <Divider className={classes.collapseDivider} />
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(Thread);
